(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-drop-alert"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sc-drop-alert')) {
  customElements.define('sc-drop-alert', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const popup = this.querySelector('.scda-popup');
      const key = 'sc-drop-alert-until-v1';
      const read = () => { try { return Number(localStorage.getItem(key)) || 0; } catch { return 0; } };
      const save = days => { try { localStorage.setItem(key, String(Date.now() + days * 86400000)); } catch {} };
      const result = this.querySelector('.scda-inline [data-scda-success], .scda-inline [data-scda-error]');
      if (result) {
        if (result.hasAttribute('data-scda-success')) save(180);
        if (location.hash.includes('scda-')) { result.scrollIntoView({block:'center'}); result.focus({preventScroll:true}); }
        return;
      }
      if (!popup || this.hasAttribute('data-design-mode') || this.hasAttribute('data-subscribed') || read() > Date.now()) return;
      let shown = false;
      const started = Date.now();
      const close = () => {
        if (popup.hidden) return;
        const hasFocus = popup.contains(document.activeElement);
        popup.hidden = true;
        save(7);
        if (hasFocus) this.querySelector('.scda-inline input[type=email]')?.focus({preventScroll:true});
      };
      popup.querySelector('.scda-close').addEventListener('click', close, {signal});
      document.addEventListener('keydown', event => { if (event.key === 'Escape' && !popup.hidden) close(); }, {signal});
      const visible = el => {
        if (!el || el.closest('details:not([open]), [hidden]')) return false;
        const style = getComputedStyle(el);
        const rect = el.getBoundingClientRect();
        return style.visibility !== 'hidden' && style.display !== 'none' && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
      };
      const blocked = () => document.hidden || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '') || Array.from(document.querySelectorAll('[aria-modal="true"], dialog[open], #shopify-pc__banner, details[open]')).some(visible);
      const check = () => {
        if (shown || read() > Date.now()) return;
        const elapsed = Date.now() - started;
        const range = document.documentElement.scrollHeight - innerHeight;
        const scrolled = range > 0 && scrollY / range >= 0.35;
        if (elapsed < 8000 || (!scrolled && elapsed < Number(this.dataset.delay) * 1000) || blocked()) return;
        const bounds = this.querySelector('.scda-inline').getBoundingClientRect();
        if (bounds.top < innerHeight && bounds.bottom > 0) return;
        shown = true;
        popup.hidden = false;
        save(7);
        clearInterval(this.timer);
      };
      this.timer = setInterval(check, 1000);
    }
    disconnectedCallback() { this.controller?.abort(); clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
